<template>
<div class="download">
    <h4>RT2000 固件下载</h4>
<div class="step_box" > 
	<div class="small_step column">
       <div class="step_item row">
         <div class="date_l">
            <h6>2018-09-05</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V3.0.0 </h1>
           <p>>修复GPS卫星显示不全的bug</p>
           <p>>修复传感器更新初始值的bug</p>
           <p><a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>           
         </div>
       </div>

      <div class="step_item row">
         <div class="date_l">
            <h6>2018-11-07</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.9.0 </h1>
           <p>>模块不装uid不能上线</p>
           <p>>添加水位计</p>
           <p><a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>           
         </div>
       </div>

      <div class="step_item row">
         <div class="date_l">
            <h6>2018-07-09</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-bigger"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7.5 </h1>
           <p>>全站仪每周期测量结束直接断电，解决徕卡全站仪测量一段时间不接受指令的问题;</p>
           <p>>修改光伏传感器显示bug;</p>
           <p>>GNSS解算不输出Rinex文件（太占空间）</p>
           <p>>增加光伏控制器，数据库添加Controller表;</p>
           <p>>修改环号int->string，数据库做相应更改;</p>
           <p>>修复全站仪回数据bug，数据tag增加uid标识：tag = uid_tag，数据库做相应更改tag:int->string;</p>
           <p>>RocBox客户端程序更新为V2.7.5版本</p>       
         </div>
       </div>


         <div class="step_item row">
         <div class="date_l">
            <h6>2018-05-02</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>leica MS系列全站仪开机等待时间由90s增加为180s,修复了该类全站仪跳周期的问题</p>      
         </div>
       </div>

       
         <div class="step_item row">
         <div class="date_l">
            <h6>2018-05-03</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>全站仪更新初始值添加全选操作</p>
           <p>>修复网平差卡死与崩溃bug</p>
           <p><a href="">云服务器版</a>
           <a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>      
         </div>
       </div>

            <div class="step_item row">
         <div class="date_l">
            <h6>2018-03-06</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7.4 </h1>
           <p>>为GNSS监测增加短信语音和声光报警功能的设置</p>
           <p>>RocBox客户端程序仍为V2.7.3版本</p>         
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2018-04-03</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>修改GNSS板卡接入设置界面的品牌选项，使用YS01, YS02, YS03分别对应司南，天宝BD982以及拓普康板卡</p>
           <p><a href="">云服务器版</a>
           <a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>      
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2017-12-06</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7.3</h1>
           <p>>根据标定结果，当前使用的双面棱镜配合MS时只需要进行棱镜常数改正(-7mm)即可 , 去掉之前为进行复杂改正<br>而作的相关功能，包括多面棱镜在内的数据库表和界面等</p> 
         </div>
       </div>


           <div class="step_item row">
         <div class="date_l">
            <h6>2017-12-19</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>修复RocMoS软件在仪器操作界面选择目标点后，棱镜常数没有正常更新的问题</p>
           <p><a href="">云服务器版</a>
           <a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>      
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2017-11-17</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7.2 </h1>
           <p>>改善gnss解算相关的界面显示和操作流程;</p>
           <p>>传感器相关，增加初始值字段，提供更新初始值功能，显示变化量由相对与初次观测值的差改为与初始值的差</p>
           <p>>对于项目使用过程中出现的传感器采集失败的问题，增加失败后多次采集的功能</p>
           <p>>软件启动时获取系统所在时区，保证软件显示的本地时间与gnss解算相关的gps时之间的正确转换</p>      
         </div>
       </div>

          <div class="step_item row">
         <div class="date_l">
            <h6>2017-11-22</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>GNSS测站增加天线类型信息, 增加到相关界面及输出的rinex文件</p>
           <p>
           <a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>      
         </div>
       </div>


          <div class="step_item row">
         <div class="date_l">
            <h6>2017-09-22</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7.1 </h1>
           <p>>修复ms系列全站仪自动测量时仪器的目标类型与rocmos设置的目标类型不一致的问题;</p>
           <p>>仪器操作和全站仪自动测量过程中，增加对仪器的棱镜常数的设置功能;</p>
           <p>>已知点集界面导入文件功能，增加目标类型和棱镜常数两个字段;</p>   
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2017-10-16</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>增加glonass卫星的数据解析、星图显示；</p>
           <p>>将跳秒数据写成文件读取，utc跳秒之后更新该文件。用来支持glonass数据正确地存储为rinex数据格式；</p>
           <p>>间隔一小时将当前接受的gnss观测数据转换成rinex 2.11版本保存到指定路径。</p>   
           <p>>支持域名的方式进行tcp连接；</p>
         </div>
       </div>


        <div class="step_item row">
         <div class="date_l">
            <h6>2017-10-24</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-m"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>软件启动时获取系统所在的时区，用来做gps时，utc和本地时间转换</p>
           <p>>客户端采集传感器数据失败时，增加最多3次的重复采集功能</p>
           <p>>为测距传感器、倾斜仪、静力水准增加初始值</p>   
           <p>>改善GNSS监测相关的ui界面显示</p>
            <p><a href="#">云服务器版</a>
           <a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>    
         </div>
       </div>


           <div class="step_item row">
         <div class="date_l">
            <h6>2016-09-18</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.7 --测试版 </h1>
           <p>>GNSS监测基站界面实现实时显示卫星星图以及信号强度，可以进行gnss的展示。目前卫星位置使用gsv<br>信息，信号强度使用rtcm数据提取，两者可能出现不一致的问题，后期可根据信号值来选择显示星图中的<br>卫星。 </p>
         </div>
       </div>


             <div class="step_item row">
         <div class="date_l">
            <h6>2016-10-10</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>具备基本的Gnss监测功能，显示各个流动站数据质量以及结算结果，需要进行测试工作。</p>  
         </div>
       </div>

              <div class="step_item row">
         <div class="date_l">
            <h6>2017-07-13</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>支持RT2000板载OEM板卡和一体接收机的接入，目前支持司南板卡以及拓普康接收机；</p>
           <p>>同时支持动态、静态基线解算，动态解算结果只用于输出展示；</p>
           <p>>支持单基站，多基站解算模式，多基站模式下进行网平差解算;</p>   
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2017-07-28</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>支持多种目标类型，面棱镜，反射片;</p> 
           <p>>支持多面棱镜(双面棱镜，360度棱镜);</p> 
         </div>
       </div>


      <div class="step_item row">
         <div class="date_l">
            <h6>2017-08-15</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>增加仪器序列号授权功能，其他版本不再提供下载</p> 
         </div>
       </div>

           <div class="step_item row">
         <div class="date_l">
            <h6>2017-09-06</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>gnss接收机直连增加tcp server的方式介入rocmos;</p> 
           <p>>分别将静力水准和测斜传感器的支持修改为上海盛迪和辉格科技的传感器;</p>
           <p>>修复RocMoS软件测站设置没有分配目标点时开始测量导致盒子重启的问题;</p>
           <p>>设置了电源控制时，全站仪观测完成关机后，增加断电操作;</p>
         </div>
       </div>
       

                  <div class="step_item row">
         <div class="date_l">
            <h6>2017-09-20</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>修复ms全站仪在自动测量的时候设置的目标类型与在RocMoS软上的设置不一致的问题;</p> 
           <p>>修复仪器在刚开机时，解析授权码错误的问题；</p>
            <p><a href="#">服务器程序</a>
           <a href="#">客户端程序</a></p>  
         </div>
       </div>
       

          <div class="step_item row">
         <div class="date_l">
            <h6>2017-06-27</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.6.2 </h1>
           <p>>用SST460倾斜传感器代替原有倾斜传感器，拥有双轴改正以及温度补偿。</p> 
           <p>>用HC-D300液压式静力水准仪代替原有静力水准仪，拥有温度补偿。</p>
            <p>
           <a href="#">客户端程序</a></p>  
         </div>
       </div>

       <div class="step_item row">
         <div class="date_l">
            <h6>2017-04-19</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.6.1 </h1>
           <p>>在项目页面增加电源控制设置，用来控制全站仪测量开始和结束时是否执行仪器开机关机操作。</p> 
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2016-05-16</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-best"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.6--稳定版 </h1>
           <p>>修复监测盒子的数据传输过程中盒子掉线的问题；</p>
           <p>>修复监测盒子在数据传输过程中数据丢失的问题；</p>
           <p>>增加了部分Gnss监测相关的界面，Gnss功能尚不完善；</p>
           <p>>监测盒子调整启动进程starter的启动控制，启动之前先kill已存在的客户端进程，同时保证各进程的启动顺序；</p>
           <p>>处理开始测量时盒子存储的全站仪观测数据没有清空的问题；</p>
           <p>>处理服务器软件界面操作以及删除在线客户端造成的程序异常问题；</p>
           <p>>取消uuid机制作为数据的唯一标识，改用客户端自增的整型数据Tag作为客户端数据标记，在服务器端采用ClientID/SensorID和客户端Tag作为数据的唯一标识</p>       
           <p>>对徕卡的仪器支持区分TS/TM系列和TCA2003两个仪器型号.</p>
           <p>>处理盒子掉线后重新进行tcp连接时导致服务器程序崩溃的问题.</p>
           <p>>限制盒子的数据库文件cache.db最大容量为50M.</p>
           <p>>gprs模块串口使用，监测程序访问/dev/ttyUSB1来获取信号值，pppd拨号进程通过/dev/ttyUSB2进行拨号.</p>
         </div>
       </div>


       
       <div class="step_item row">
         <div class="date_l">
            <h6>2016-09-26</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>处理客户端软件在最后一个点测量失败时，导致客户端程序崩溃的问题.</p> 
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2016-10-18</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>修复CMeasDataPage.cpp中的bug，为FailType::NotFailType添加数据，避免因数据越界导致程序崩溃.</p> 
           <p>>修复端口被占用导致程序崩溃的问题，弹出对话框让用户设置端口，并打开成功后再进入软件。</p>
         </div>
       </div>

              <div class="step_item row">
         <div class="date_l">
            <h6>2016-10-31</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>> 解决数据处理时，读取的气象数据错误的问题。</p> 
         </div>
       </div>

      <div class="step_item row">
         <div class="date_l">
            <h6>2016-11-14</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>> 添加对拓普康gpt9000,IS系列全站仪的支持。</p> 
           <p>>增加了盒子的远程升级控制功能。</p>
         </div>
       </div>

         <div class="step_item row">
         <div class="date_l">
            <h6>2016-11-29</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>修改tcp传输协议中的缓冲区大小，统一为50K(50*1024)</p> 
           <p>>在测站配置中，最多允许一个测站添加500个目标点，避免因目标点数量过多，导致发送的配置协议的长度超过缓冲区大小。</p>
         </div>
       </div>

        <div class="step_item row">
         <div class="date_l">
            <h6>2016-12-02</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>在测量结果页面增加导出按钮，导出当前点的所有测量结果。</p> 
           <p>>在仪器操作界面增加保存按钮，将测量结果保存到点集中。</p>
         </div>
       </div>

          <div class="step_item row">
         <div class="date_l">
            <h6>2017-02-10</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>>监测状态界面，为开始按钮增加立即开始选项.</p> 
         </div>
       </div>

                 <div class="step_item row">
         <div class="date_l">
            <h6>2017-04-14</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>> 修复在没有添加全站仪设备的项目上开始测量，导致删除其他项目原始数据的问题。</p> 
         </div>
       </div>

      <div class="step_item row">
         <div class="date_l">
            <h6>2017-04-19</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>> 修复服务器软件在空项目上开始测量时，会删除其他项目观测数据的问题。此修复值影响服务器软件，不涉及数据库和客户端软件。</p> 
         </div>
       </div>
         

          <div class="step_item row">
         <div class="date_l">
            <h6>2017-05-16</h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line-short"></div>
         </div>
         <div class="title_r">
           <h1>Update </h1>
           <p>> 处理对话框enter键响应不正常的问题。</p> 
         </div>
       </div>
        

         <div class="step_item row">
         <div class="date_l">
            <h6></h6>
         </div>
         <div class="y_axis column">
           <div class="circle"></div>
           <div class="y_line"></div>
         </div>
         <div class="title_r">
           <h1>RocMoS V2.5 </h1>
           <p>>修复空项目时进入报警设置，平差时测站中误差超限导致程序崩溃的问题，修改服务器名称时修改项目所在文件夹路径等问题；</p> 
           <p>>修复全站仪观测数据进度显示错误的问题；</p>
           <p>>修改点集对话框中点名的排序方式；</p>
           <p>>配置测站测量点时，增加测量顺序配置功能；</p>
           <p>>增加gnss的设置功能</p>
         </div>
       </div>


       
	</div>
</div>
<foot></foot>






    </div>
</template>
<script>
import footer from "../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>
<style>
.download {
  overflow: hidden;
}
.download h4 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  text-align: center;
  padding-top: 0.56rem;
  padding-bottom: 0.77rem;
}
.step_box {
  width: 100%;
  height: 6.4rem;
  /* background: pink; */
  margin-bottom: 1.46rem;
  cursor: pointer;
}
.small_step {
  overflow: auto;
  width: 120%;
  height: 100%;
  overflow-x: hidden;
  margin-left: 3.9rem;
}
.date_l{
  width: 1.12rem;
}
.date_l h6 {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.circle {
  width: 0.1rem;
  height: 0.1rem;
  background: rgba(255, 255, 255, 1);
  border: 0.06rem solid rgba(67, 148, 208, 1);
  border-radius: 50%;
  margin-left: 0.2rem;
  margin-right: 0.19rem;
}
.y_line {
  width: 0.02rem;
  height: 1.4rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.01rem;
  margin-left: 0.3rem;
  margin-right: 0.32rem;
}
.y_line-bigger{
  width: 0.02rem;
  height: 2.4rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.01rem;
  margin-left: 0.3rem;
  margin-right: 0.32rem;
}
.y_line-short{
   width: 0.02rem;
  height: 1.2rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.01rem;
  margin-left: 0.3rem;
  margin-right: 0.32rem;
}
.y_line-m{
   width: 0.02rem;
  height: 1.8rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.01rem;
  margin-left: 0.3rem;
  margin-right: 0.32rem;
}
.y_line-best{
     width: 0.02rem;
  height: 3.7rem;
  background: rgba(67, 148, 208, 1);
  border-radius: 0.01rem;
  margin-left: 0.3rem;
  margin-right: 0.32rem;
}
.title_r h1 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
}
.title_r p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.title_r p:last-child {
  padding-top: 0.15rem;
}
.title_r p a {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(67, 148, 208, 1);
  text-decoration: none;
}
</style>





// WEBPACK FOOTER //
// src/homepages/download.vue